module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("TOR BOOKS BY THOMAS HARLAN")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("IN THE TIME OF THE SIXTH SUN")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("WASTELAND OF FLINT")]), _vm._v(" "), _c('p', {
    staticClass: "center3a"
  }, [_vm._v("HOUSE OF REEDS")]), _vm._v(" "), _c('p', {
    staticClass: "center4"
  }, [_vm._v("OATH OF EMPIRE")]), _vm._v(" "), _c('p', {
    staticClass: "center4a"
  }, [_vm._v("THE SHADOW OF ARARAT")]), _vm._v(" "), _c('p', {
    staticClass: "center4b"
  }, [_vm._v("THE GATE OF FIRE")]), _vm._v(" "), _c('p', {
    staticClass: "center4c"
  }, [_vm._v("THE STORM OF HEAVEN")]), _vm._v(" "), _c('p', {
    staticClass: "center4d"
  }, [_vm._v("THE DARK LORD")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36486fa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter001.vue
// module id = 60
// module chunks = 0